import { OverlayModule } from '@angular/cdk/overlay';
import { Component, OnInit, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { CashierNewOptions, LastKnownProductService, NavigationService, PlatformProductMapConfig } from '@frontend/vanilla/core';
import { firstValueFrom } from 'rxjs';

import { CashierConfig } from './cashier.client-config';
import { CashierRouteAction } from './cashier.models';
import { CashierService } from './cashier.service';

/**
 * @stable
 */
@Component({
    imports: [OverlayModule],
    selector: 'lh-cashier',
    template: '',
})
export class CashierComponent implements OnInit {
    private readonly activatedRoute = inject(ActivatedRoute);
    private readonly cashierConfig = inject(CashierConfig);
    private readonly navigation = inject(NavigationService);
    private readonly lastKnownProductService = inject(LastKnownProductService);
    private readonly cashierService = inject(CashierService);
    private readonly platformProductMapConfig = inject(PlatformProductMapConfig);

    async ngOnInit() {
        await Promise.all([firstValueFrom(this.cashierConfig.whenReady), firstValueFrom(this.platformProductMapConfig.whenReady)]);

        const options: CashierNewOptions = {
            trackerId: this.navigation.location.search.get('trackerId') || this.cashierConfig.trackerIds.menu,
            returnUrl: this.navigation.location.search.get('returnUrl') || this.lastKnownProductService.get().url,
            replaceInHistory: true,
        };

        switch ((this.activatedRoute.snapshot.params.action || '').toLowerCase()) {
            case CashierRouteAction.Deposit:
                this.cashierService.goToCashierDeposit(options);
                break;
            case CashierRouteAction.Withdrawal:
                this.cashierService.goToCashierWithdrawal(options);
                break;
            case CashierRouteAction.TransactionHistory:
                this.cashierService.goToTransactionHistory(options);
                break;
            case CashierRouteAction.PaymentPreferences:
                this.cashierService.goToPaymentPreferences(options);
                break;
            default:
                this.cashierService.goToCashier(options);
                break;
        }
    }
}
